var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 13.72",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.82 6.54C8.07 4.37 4.34 2.19.59.05.33-.1 0 .08 0 .37v12.97c0 .18.09.26.21.32.09.06.23.09.38 0 3.76-2.17 7.48-4.31 11.24-6.48.23-.15.23-.5 0-.65z",
    fill: "#1b1b1b",
    "data-name": "Layer 1"
  })));
}
export default SvgVideoPlay;